import { render, staticRenderFns } from "./topController.vue?vue&type=template&id=173cbed4&"
import script from "./topController.vue?vue&type=script&lang=ts&"
export * from "./topController.vue?vue&type=script&lang=ts&"
import style0 from "./topController.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports